module.exports = __webpack_public_path__ + "static/media/professional-services-landscape.ad044557.jpg";